import icon from "../../assets/deployment.svg";
import type { Property } from "../../types";

export const deployment: Property = {
  id: "deployment",
  title: "deployment.title",
  icon,
};
